'use client';

import { VStack, HStack } from '@terra/ui-styled-system';
import { Text } from '../../../components/text';
import { Button } from '../../../components/button';
import { Tooltip } from '../../../components/tooltip';
import type { OwaspRiskFactorSelectorProps } from '../types';

const FACTOR_SCORE_OPTIONS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9] as const;

export function FactorSelector({
  title,
  description,
  value,
  onChange,
  footer,
}: OwaspRiskFactorSelectorProps) {
  return (
    <VStack gap={1.5} alignItems="stretch" w="full">
      <Tooltip
        openDelay={500}
        positioning={{ strategy: 'fixed', placement: 'top' }}
        title={description}
        maxW="320px"
      >
        <Text
          fontSize="xs"
          fontWeight="medium"
          color="fg.muted"
          w="fit-content"
        >
          {title}
        </Text>
      </Tooltip>
      <HStack gap={1} flexWrap="wrap">
        {FACTOR_SCORE_OPTIONS.map((option) => {
          const isSelected = value === option;

          return (
            <Button
              key={option}
              size="xs"
              variant={isSelected ? 'subtle' : 'ghost'}
              onClick={() => onChange(option)}
              fontSize="xs"
              px={0}
              py={1}
              minW="7"
              minH="7"
              flexShrink={0}
              fontWeight={isSelected ? 'medium' : 'normal'}
              bg={isSelected ? 'bg.muted' : undefined}
              borderWidth="1px"
              borderColor={isSelected ? 'border.default' : 'border.subtle'}
              color={isSelected ? 'fg.default' : 'fg.muted'}
              _hover={{
                bg: isSelected ? 'bg.muted' : 'bg.hover',
                borderColor: 'border.default',
              }}
            >
              {option}
            </Button>
          );
        })}
      </HStack>
      {footer}
    </VStack>
  );
}
